import styled, { css } from 'styled-components';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

import Block from 'components/structure/Block/Block';

export const BlockHiddenOnMobile = styled(Block)`
  display: none;

  ${breakpointsMedia({
    md: css`
      display: flex;
    `,
  })}
`;

BlockHiddenOnMobile.displayName = 'BlockHiddenOnMobile';
